import { SparklesIcon } from "lucide-react";

import { Column, Text } from "@/components";
import { Button } from "@/components/ui/button";

import { useSuccessToast } from "@/hooks/useSuccessToast";
import { useRateAllCandidacies } from "@/hooks/mutations/useRateAllCandidacies";

export const RateAllCandidaciesSection = () => {
  /* Database CRUD Operations */
  // Update
  const { mutate: rateAllCandidacies, isPending: isRatingAllCandidacies } =
    useRateAllCandidacies();

  /* Misc Hooks */
  const successToast = useSuccessToast();

  /* Render */
  const render = () => {
    return (
      <Column className="items-center justify-center gap-4 rounded-lg border border-dashed border-slate-200 p-4">
        <Text>
          Rate all candidacies for this job using the agentic scoring system
        </Text>
        <Button
          type="button"
          disabled={isRatingAllCandidacies}
          onClick={() => {
            rateAllCandidacies(undefined, {
              onSuccess: (response) => {
                successToast({
                  description: response.message,
                });
              },
            });
          }}
        >
          <SparklesIcon className="h-4 w-4" />
          Rate All Candidacies
        </Button>
      </Column>
    );
  };

  return render();
};
